import React from "react";
import { Modal } from "@mui/material";
import successLogo from "assets/validationSuccess.png";

const SuccessModal = (props) => {
  return (
    <Modal onClose={props.onClose} open={true}>
      <div className="support-modal">
        <img
          src={successLogo}
          alt="SUCCESS"
          className="spm-icon"
          width={50}
          height={50}
        />
        <div className="spm-title">Thank you for contacting us.</div>
        <p className="spm-content">
          We will get in touch with you soon.
          <br />
          <br />
          Please note the reference ID
          <br />
          <span className="spm-id">{props.id}</span> for future communications.
        </p>
        <button className={`submit spm-btn`} onClick={props.onClose}>
          OK
        </button>
      </div>
    </Modal>
  );
};

export default SuccessModal;
